import { Navigate } from 'react-router-dom';
import { routes } from '../../shared/navigation/routes';

function FavoritesRedirect() {
  return <Navigate to={routes.myRecipes} replace />;
}

export default FavoritesRedirect;
export { FavoritesRedirect };
